/**
 * Cross-tab session sync (roadmap 3.4): BroadcastChannel('mdt-session'). Every tab of the app hears when
 * another recorded activity (so its idle deadline moves too) and when another signed out (so it wipes and
 * leaves as well). Messages carry times and reasons only, never personal data.
 */
export type SessionMessage =
  | { type: 'activity'; deadline: number; recordedAt: number }
  | { type: 'logout'; reason: 'logout' | 'idle' | 'expired'; mode: 'standard' | 'shared' }
  | { type: 'signed-in' };

export const SESSION_CHANNEL = 'mdt-session';

export type SessionChannel = {
  post(m: SessionMessage): void;
  subscribe(fn: (m: SessionMessage) => void): () => void;
  close(): void;
};

export function openSessionChannel(): SessionChannel {
  if (typeof BroadcastChannel === 'undefined') {
    return { post() {}, subscribe: () => () => {}, close() {} };
  }
  const ch = new BroadcastChannel(SESSION_CHANNEL);
  const listeners = new Set<(m: SessionMessage) => void>();
  ch.onmessage = (e: MessageEvent) => {
    const m = e.data as SessionMessage | null;
    if (m && typeof m === 'object' && typeof m.type === 'string') for (const fn of listeners) fn(m);
  };
  return {
    post: (m) => ch.postMessage(m),
    subscribe(fn) {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    close: () => ch.close(),
  };
}
